// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.menu-img[data-v-74b96216] {
  max-width: 24px;
}
.v-list__group.v-list__group--active[data-v-74b96216]:after,
.v-list__group.v-list__group--active[data-v-74b96216]:before {
  display: none;
  contain: '';
}
.v-list__group__header > div[data-v-74b96216] {
  width: 100%;
}
.sub-menu-list[data-v-74b96216] {
  padding-left: 56px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
